import { Box, Typography } from "@mui/material";
import React from "react";
import Orangelogo from "../../assets/images/Orangelogo.png";
import AccordianIcon from "../../assets/icons/AccordianIcon.png";
import { Link } from "react-router-dom";

const OurValues = () => {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "1440px" },
        margin: "0 auto",
        marginTop: { xs: "4rem", sm: "3rem", md: "2rem" },
        display: "flex",
        flexDirection: { xs: "column", sm: "column" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 3rem" },
      }}
    >
      <Link to="/Link"></Link>
      <Box
        sx={{
          width: { xs: "100%", sm: "100%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "0.1rem", sm: "2rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            color: "rgba(35, 35, 37, 1)", // Add your desired color here
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.8rem",
          }}
        >
          WHAT WE BELIEVE IN
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "1.2rem",
          }}
        >
          Our Single Unwavering{" "}
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>
            Operating Principle
          </span>
        </Typography>
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "70%", sm: "90%" },
          height: "3.8rem",
          borderRadius: "1rem",
          backgroundColor: "rgba(236, 235, 235, 1)",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          margin: "0 auto",
          marginTop: { xs: "1.5rem", sm: "3rem" },
          display: "flex",
          alignItems: "center",
          padding: "0.5rem 0 0.5rem 1rem",
          position: "relative",
        }}
      >
        <Typography
          sx={{
            color: "rgba(83, 82, 82, 1)",
            fontSize: { xs: "0.8rem", sm: "1.2rem" },
            fontFamily: "Plus Jakarta Sans",
          }}
        >
          Digital first in everything
        </Typography>

        <Box
          sx={{
            width: { xs: "3rem", sm: "3.6rem" },
            right: "-2%",
            position: "absolute",
            top: "20%",
          }}
        >
          <img src={AccordianIcon} alt="" width="100%" />
        </Box>
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "70%", sm: "90%" },
          height: "3.8rem",
          borderRadius: "1rem",
          position: "relative",
          backgroundColor: "rgba(236, 235, 235, 1)",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          margin: "0 auto",
          marginTop: "1.6rem",
          display: "flex",
          alignItems: "center",
          padding: "0.5rem 0 0.5rem 1rem",
        }}
      >
        <Typography
          sx={{
            color: "rgba(83, 82, 82, 1)",
            fontSize: { xs: "0.8rem", sm: "1.2rem" },
            fontFamily: "Plus Jakarta Sans",
          }}
        >
          Uncompromised quality of data
        </Typography>
        <Box
          sx={{
            width: { xs: "3rem", sm: "3.6rem" },
            right: "-2%",
            position: "absolute",
            top: "20%",
          }}
        >
          <img src={AccordianIcon} alt="" width="100%" />
        </Box>
      </Box>
      <Box
        sx={{
          width: { xs: "100%", md: "70%", sm: "90%" },
          height: "3.8rem",
          borderRadius: "1rem",
          position: "relative",
          backgroundColor: "rgba(236, 235, 235, 1)",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          margin: "0 auto",
          marginTop: "1.6rem",
          display: "flex",
          alignItems: "center",
          padding: "0.5rem 0 0.5rem 1rem",
        }}
      >
        <Typography
          sx={{
            color: "rgba(83, 82, 82, 1)",
            fontSize: { xs: "0.8rem", sm: "1.2rem" },
            fontFamily: "Plus Jakarta Sans",
          }}
        >
          Problem solving, not data reporting{" "}
        </Typography>
        <Box
          sx={{
            width: { xs: "3rem", sm: "3.6rem" },
            right: "-2%",
            position: "absolute",
            top: "20%",
          }}
        >
          <img src={AccordianIcon} alt="" width="100%" />
        </Box>
      </Box>
      <Box
        sx={{
          width: { xs: "100%", md: "70%", sm: "90%" },
          height: { xs: "3.8rem", sm: "auto", md: "3.8rem" },
          minHeight: "3.8rem",
          position: "relative",
          borderRadius: "1rem",
          backgroundColor: "rgba(236, 235, 235, 1)",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          margin: "0 auto",
          marginTop: "1.6rem",
          display: "flex",
          alignItems: "center",
          padding: "0.5rem 0 0.5rem 1rem",
        }}
      >
        <Typography
          sx={{
            color: "rgba(83, 82, 82, 1)",
            fontSize: { xs: "0.8rem", sm: "1.2rem" },
            fontFamily: "Plus Jakarta Sans",
            width: "90%",
          }}
        >
          Brand and Business Partner - always start with the client business
          question
        </Typography>

        <Box
          sx={{
            width: { xs: "3rem", sm: "3.6rem" },
            right: "-2%",
            position: "absolute",
            top: "20%",
          }}
        >
          <img src={AccordianIcon} alt="" width="100%" />
        </Box>
      </Box>
      <Box
        sx={{
          width: { xs: "100%", md: "70%", sm: "90%" },
          height: { xs: "3.8rem", sm: "auto", md: "3.8rem" },
          minHeight: "3.8rem",
          borderRadius: "1rem",
          backgroundColor: "rgba(236, 235, 235, 1)",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          margin: "0 auto",
          marginTop: "1.6rem",
          display: "flex",
          alignItems: "center",
          padding: "0.5rem 0 0.5rem 1rem",
          position: "relative",
        }}
      >
        <Typography
          sx={{
            color: "rgba(83, 82, 82, 1)",
            fontSize: { xs: "0.8rem", sm: "1.2rem" },
            fontFamily: "Plus Jakarta Sans",
            width: "90%",
          }}
        >
          People first - for our employees, our partners, our clients{" "}
        </Typography>

        <Box
          sx={{
            width: { xs: "3rem", sm: "3.6rem" },
            right: "-2%",
            position: "absolute",
            top: "20%",
          }}
        >
          <img src={AccordianIcon} alt="" width="100%" />
        </Box>
      </Box>
    </Box>
  );
};

export default OurValues;
